import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography, Chip, Box } from '@mui/material'
import { HiOutlineCheck, HiOutlineXCircle } from 'react-icons/hi'
import { QRCodeCanvas } from 'qrcode.react'

const DeviceDetailsModal = ({ open, onClose, device }) => {
    if (!device) return null

    const formatDate = (dateStr) => (dateStr ? new Date(dateStr).toLocaleDateString() : 'N/A')

    const InfoRow = ({ label, value }) => (
        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
            <Typography color="text.secondary" flex={1}>
                {label}
            </Typography>
            <Typography flex={1} textAlign="left">
                {value || 'N/A'}
            </Typography>
        </Stack>
    )

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Device Details</DialogTitle>
            <DialogContent
                sx={{
                    maxHeight: '70vh',
                    overflowY: 'auto'
                }}
                dividers
            >
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                    {/* QR Code */}
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <QRCodeCanvas
                            value={device.id || 'N/A'}
                            size={180}
                            bgColor="#ffffff"
                            fgColor="#000000"
                            level="H"
                        />
                    </Box>

                    {/* Device Info */}
                    <Stack spacing={1} flex={1}>
                        <InfoRow label="Category:" value={device.category} />
                        <InfoRow label="Brand:" value={device.brand} />
                        <InfoRow label="Model:" value={device.model} />
                        <InfoRow label="Serial Number:" value={device.serialNumber} />
                        <InfoRow label="Assigned Date:" value={formatDate(device.assignedDate)} />
                        <InfoRow label="Accepted Date:" value={formatDate(device.termsAcceptedAt)} />
                        <InfoRow
                            label="Terms Accepted:"
                            value={
                                device.isTermsAccepted ? (
                                    <Chip icon={<HiOutlineCheck />} label="Accepted" color="success" size="small" />
                                ) : (
                                    <Chip icon={<HiOutlineXCircle />} label="Not Accepted" color="error" size="small" />
                                )
                            }
                        />
                        <InfoRow label="Returned Date:" value={formatDate(device.returnedDate)} />
                    </Stack>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeviceDetailsModal
